import {createApp, markRaw} from 'vue';
import {createPinia} from 'pinia';
import "core-js/stable";
import App from '@/console-new/App.vue';
import router from '@/console-new/router';
import { setupCalendar, DatePicker } from 'v-calendar';
import Vue3Sanitize from "vue-3-sanitize";
import * as Sentry from "@sentry/vue";
import "core-js/stable";

import '@/shared/global';
import longPress from '@/shared/directives/longpress';
import swipe from '@/shared/directives/swipe';
import '@/console-new/global';
import '@/console-new/assets/scss/main.scss';
import sharedMixin from '@/shared/mixins';
import consoleMixin from '@/console-new/mixins';
import 'v-calendar/style.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

const pinia = createPinia();
const app = createApp(App);

if(import.meta.env.VITE_MODE && import.meta.env.VITE_MODE === 'production') {
	Sentry.init({
		app,
		dsn: "https://968d37316c014c6b2c3856c805e3088b@o4506326846078976.ingest.sentry.io/4506326848569344",
		integrations: [
			Sentry.browserTracingIntegration({ router }),   // <- replaces BrowserTracing + custom instr.
		],
		tracePropagationTargets: [
			`https://${import.meta.env.VITE_QROMO_ENV}.it/API/`,
		],
		environment: import.meta.env.VITE_QROMO_ENV,
		tracesSampleRate: 0.2,
	});
}

pinia.use(({ store }) => { store.router = markRaw(router) });
app.use(pinia);
app.use(router);
app.use(Vue3Sanitize, {allowedTags: []});
app.mixin(sharedMixin);
app.mixin(consoleMixin);
app.directive('longpress', longPress);
app.directive('swipe', swipe);
app.use(setupCalendar, {});
app.component('DatePicker', DatePicker);
app.mount('#app');
